








































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import ErrorMessages from '@/components/ErrorMessages.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import Api from '@/api'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { required } from 'vuelidate/lib/validators'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  components: {
    ModalV2,
    ErrorMessages,
    InputValidator,
    InputV2
  }
})
export default class AddSftpUserModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)

  name: string = ''

  isLoading: boolean = false

  validations () {
    return {
      name: { required }
    }
  }

  async createUser () {
    this.$v.$touch()
    if (this.$v.$anyError) return

    if (!await this.chainModuleInstance.checkSftpUser(this.name)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'User Already Exists',
        header: `Error`,
        icon: 'warning'
      })
      return
    }

    try {
      this.isLoading = true
      const token = Api.getToken()
      await this.chainModuleInstance.downloadSftpUserKey({ username: this.name, token })
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: 'SFTP user successfully created',
        header: `Create SFTP User`,
        icon: 'warning'
      })
      this.$emit('close')
    } catch (err) {
      console.log(err)
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Failed to create SFTP user',
        header: `Create SFTP User`,
        icon: 'warning'
      })
    } finally {
      this.isLoading = false
    }
  }
}
